import { render, staticRenderFns } from "./chatBanner.vue?vue&type=template&id=338b9abd"
import script from "./chatBanner.vue?vue&type=script&lang=js"
export * from "./chatBanner.vue?vue&type=script&lang=js"
import style0 from "./chatBanner.vue?vue&type=style&index=0&id=338b9abd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports